import SymptomSearcher from './SymptomSearcher.jsx';

export default SymptomSearcher;